module.exports = __webpack_public_path__ + "static/media/Prevea360_Medicare_Tag_Logo.cb677902.png";